import React from 'react';
import moment from 'moment';
import intl from 'react-intl-universal';
import { debounce, isHtml } from '../../utils/util';
import './OneComment.scss';
import { alpha } from '../../utils/color';

const getTime = timeString => {
  const date = moment(timeString - 0);
  const now = moment();
  //小于1天用 “XX分钟之前”之类的表示方式
  const diff = now.diff(date, 'days');
  //20180826和产品讨论：1天以上，如果跨年，显示年月日时分；如果不跨年 ， 在30天内显示 X天前，超过显示年月日时分
  if (diff <= 1) {
    return date.fromNow();
  } else {
    if (date.year() !== now.year()) {
      return date.format('YYYY-MM-DD HH:mm');
    } else if (diff <= 30) {
      return date.fromNow();
    } else {
      return date.format('YYYY-MM-DD HH:mm');
    }
  }
};

const RedPackContent = props => {
  let { content } = props;
  let sub = content.replace(/^\$\$REDPACKAGE/gi, '');
  let result = JSON.parse(sub);

  return (
    <div
      className="red-pack-content"
      onClick={debounce(() => {
        // 判断是否需要登录
        if (props.onClick) {
          props.onClick('redpack', result.id, {
            content: result.content,
            postname: props.nickname,
            postphoto: props.photo
          });
        }
      })}
    >
      <div className="main-pack-content">
        <div className="content-left">
          <img
            src={require('../../assets/redpack/red-pack-normal.png')}
            className={'red-pack-normal'}
            alt=""
          />
        </div>
        <div className="content-right">
          <div className="real-content">{result.content}</div>
          <div>{intl.get('Open Red Packet')}</div>
        </div>
      </div>
      <div className="footer">
        <div className="fz10">{intl.get('Red Packet')}</div>
      </div>
    </div>
  );
};

export const OneComment = props => {
  const { content, istop, master } = props;
  const { h1Color, h2Color, mainColor } = props;
  let realContent = '';
  try {
    realContent =
      (content || '').indexOf('$$REDPACKAGE') === 0
        ? RedPackContent(props)
        : decodeURIComponent(content);
  } catch (e) {
    console.error(`content cannot be decoded:`, content);
  }
  return (
    <div className="one-comment-wrapper">
      <img
        src={props.photo || require('../../assets/avatar_default.png')}
        alt=""
        className="avatar"
      />
      <div
        className="row-one"
        style={{
          color: alpha(h1Color, 0.1)
        }}
      >
        <div className="row-one-core">
          <div className="name">
            <span className="real-name" style={{ color: h2Color }}>
              {props.nickname || intl.get('Guest')}
            </span>
            {istop * 1 ? (
              <div className="top-comment">{intl.get('Top')}</div>
            ) : null}
            {typeof props.onDelete === 'function' && (
              <div className="delete" onClick={props.onDelete}>
                {intl.get('Delete')}
              </div>
            )}
          </div>

          <div className="time" style={{ color: h2Color }}>
            {getTime(props.createtime)}
          </div>
        </div>
        {isHtml(realContent) && master * 1 ? (
          <div
            className="content"
            style={{ color: h1Color }}
            dangerouslySetInnerHTML={{ __html: realContent }}
          />
        ) : (
          <div className="content" style={{ color: h1Color }}>
            {realContent}
          </div>
        )}
      </div>
    </div>
  );
};
export const NoComments = props => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        flexDirection: 'column',
        paddingBottom: 15
      }}
    >
      <img
        src={require('../../assets/no-comments.png')}
        style={{ width: 188, height: 155, marginTop: 50 }}
        alt=""
      />
      <span style={{ marginTop: 15, color: props.color || '#19304C' }}>
        {intl.get('No comments')}
      </span>
    </div>
  );
};
